import { setFontDetailsToContext } from './set-font-details-to-context.js';

export const renderTextToCanvas = (
  ctx: CanvasRenderingContext2D,
  text: string,
  type: 'value' | 'label',
  x: number,
  y: number,
) => {
  setFontDetailsToContext(ctx, type);
  ctx.fillText(text, x, y);
};
